/** Toate mărcile și mașinile din `data/`, incluse în build. */
import brandsJson from '../../data/brands.json';
import type { Brand, BrandList, VehicleDefinition } from './types';

const files = import.meta.glob('../../data/vehicles/*.json', { eager: true, import: 'default' }) as Record<string, VehicleDefinition>;

export const BRANDS: Brand[] = (brandsJson as BrandList).brands;
export const VEHICLES: VehicleDefinition[] = Object.values(files).sort((a, b) => BRANDS.findIndex((x) => x.id === a.brandId) - BRANDS.findIndex((x) => x.id === b.brandId) || a.year - b.year);
export const BRAND_IDS = BRANDS.map((b) => b.id);
export const brandOf = (v: VehicleDefinition) => BRANDS.find((b) => b.id === v.brandId) as Brand;
